import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { isDefined } from "Utils/functions";

export const getProductSubtitle = (
  product: InsuranceProduct,
): string | undefined => {
  return getProductLicensePlateNumber(product);
};

const getProductLicensePlateNumber = (
  product: InsuranceProduct,
): string | undefined => {
  return product.name === INSURANCE_NAME_VALUE.CAR ||
    product.name === INSURANCE_NAME_VALUE.MOPED ||
    product.name === INSURANCE_NAME_VALUE.MOTORCYCLE ||
    product.name === INSURANCE_NAME_VALUE.TRACTOR ||
    product.name === INSURANCE_NAME_VALUE.VETERAN_AUTO ||
    product.name === INSURANCE_NAME_VALUE.CARAVAN ||
    product.name === INSURANCE_NAME_VALUE.TRAILER
    ? product.licensePlateNumber?.toUpperCase()
    : undefined;
};

export const storedChildAndChildHealthProduct = (
  storedProduct: InsuranceProduct | undefined | null,
  twoProductsInCart: boolean,
): boolean => {
  if (!isDefined(storedProduct)) {
    return false;
  }
  return (
    storedProduct.name === INSURANCE_NAME_VALUE.NEW_CHILD && twoProductsInCart
  );
};
